module.exports = __webpack_public_path__ + "img/14.0e37a5f1.png";